import Button from '@jetbrains/ring-ui/components/button/button'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import List from '@jetbrains/ring-ui/components/list/list'
import Toggle, {Size} from '@jetbrains/ring-ui/components/toggle/toggle'
import type {MouseEventHandler} from 'react'
import {useCallback, useMemo} from 'react'

import {useSyncedBooleanQueryParam} from '../../../../../../../../../hooks/routes'
import {UserProperties} from '../../../../../../../../../utils/userProperties'
import PopupMenu from '../../../../../../../../common/Popup/PopupMenu'

import styles from './ViewToggle.css'

type Props = {className?: string}

const stopPropagation: MouseEventHandler<HTMLElement> = e => {
  e.stopPropagation()
}

function ViewToggle({className}: Props) {
  const [showFiles, setShowFiles] = useSyncedBooleanQueryParam({
    param: 'showFiles',
    userProperty: UserProperties.SHOW_ALL_CHANGES_FILES,
  })
  const [showGraph, setShowGraph] = useSyncedBooleanQueryParam({
    param: 'showGraph',
    userProperty: UserProperties.SHOW_CHANGES_GRAPH,
    defaultTrue: true,
  })

  const onToggleShowFiles = useCallback(() => setShowFiles(!showFiles), [setShowFiles, showFiles])
  const onToggleShowGraph = useCallback(() => setShowGraph(!showGraph), [setShowGraph, showGraph])

  const renderItem = useCallback(
    (label: string, value: boolean, onChange: () => void) => (
      <div role="presentation" onClick={stopPropagation}>
        <Toggle size={Size.Size16} checked={value} onChange={onChange} />
        <span className={styles.itemLabel}>{label}</span>
      </div>
    ),
    [],
  )

  const items = useMemo(
    () => [
      {
        key: 'ALL_FILES',
        label: 'All files',
        template: renderItem('All files', showFiles, onToggleShowFiles),
        rgItemType: List.ListProps.Type.CUSTOM,
        disabled: true,
      },
      {
        key: 'GRAPH',
        label: 'Graph',
        template: renderItem('Graph', showGraph, onToggleShowGraph),
        rgItemType: List.ListProps.Type.CUSTOM,
        disabled: true,
      },
    ],
    [onToggleShowFiles, onToggleShowGraph, renderItem, showFiles, showGraph],
  )

  return (
    <Dropdown className={className} anchor={<Button dropdown>{'View '}</Button>}>
      <PopupMenu closeOnSelect data={items} />
    </Dropdown>
  )
}

export default ViewToggle
